export default __webpack_public_path__ + "static/media/3.1c46b2fe.jpg";